import React from "react";
// components
// import ChooseCard from "../components/ChooseCard";
import Navbar from "components/Navbars/AuthNavbar.js";
import Footer from "components/Footers/Footer.js";
import { validateEmail } from "utils/StaticFunctions";
import tw from "twin.macro";
import { Link } from "react-router-dom";
import CounselingModal from '../components/Modal/CourseEnroll';

import java_img from './images/java.png';
import net_img from './images/net.jpg';
import cloud_img from './images/aws.jpg';
import sf_img from './images/salesforce.jpeg';
import big_img from './images/bigdata.png';
import ttc_img from './images/ttc1.jpg';
import Flippy, { FrontSide, BackSide } from 'react-flippy';
import './Landing.css';

import { backgroundColor } from "tailwindcss/defaultTheme";

export default function Landing() {

  const [formState, setFormState] = React.useState({
    name: null,
    email: null,
    phone: null,
    message: null,
  });
  const [formSubmitStatus, setFormSubmitStatus] = React.useState(false);
  const [errorState, setErrorState] = React.useState(false);
  const [isCounseling, setCounseling] = React.useState(false);

  const handleFormStateChange = (event) => {
    setFormState({
      ...formState,
      [event.target.name]: event.target.value,
    });
    setFormSubmitStatus(false);
    if (formState.name === null && formState.email === null) {
      setErrorState(false);
    } else {
      setErrorState(true);
    }
  };
  const submitContactUsForm = (e) => {
    if (formState.name === null) {
      return;
    }
    if (formState.email === null) {
      return;
    }
    if (!validateEmail(formState.email)) {
      return;
    }
    console.log("print the error state", errorState);
    fetch("https://vegetable-backend.herokuapp.com/api/v1/service/contact-us", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formState),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setFormSubmitStatus(true);
        } else {
          setFormSubmitStatus(false);
        }
      })
      .catch((err) => {
        setFormSubmitStatus(false);
        console.log(err);
      });
    e.preventDefault();
  };
  return (
    <>
      <Navbar transparent />
      <main>
        {isCounseling &&
          <CounselingModal
            modalName="counseling"
            setCourseEnroll={setCounseling}
          />
        }
        <div className="relative flex content-center items-center justify-center min-h-screen-80">
          <div
            className="ttc_background absolute top-0 w-full h-full bg-center bg-cover"
            
          >
            <span
              id="blackOverlay"
              className="w-full h-full absolute opacity-50 bg-black"
            ></span>
          </div>
          <div className="container relative mx-auto">
            <div className="items-center flex flex-wrap">
              <div className="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
                <div>
                  <h1 className="text-white font-semibold text-5xl mt-4">
                    Tech Talent Connect
                  </h1>
                  <p className="mt-4 text-lg text-blueGray-200">
                  Together lets grow froward. Tech talent connect is a global provider of recruitments  and staffing services
                  </p>
                  <p className="mt-4 text-lg text-blueGray-200">
                    We represent you to fortune 500+ companies and industries with unique work force solutions. Your innovation combined with our training and deployment program can create wonders.
                  </p>
                  {/* <Link to="/courses">
                    <button tw="border-none mt-6 px-12 py-3 bg-blue-600 hover:bg-blue-500 focus:outline-none text-white rounded shadow-md text-base">
                      View Courses
                    </button>
                  </Link> */}
                  
                </div>
              </div>
            </div>
          </div>
          <div
            className="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-blueGray-200 fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>
        </div>

        <section className="pb-20 bg-blueGray-200 -mt-24">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap">
              <div className="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-red-400">
                      <i className="fas fa-award"></i>
                    </div>
                    <h6 className="text-xl font-semibold">
                      IT Services
                    </h6>
                    <p className="mt-2 mb-4 text-blueGray-500">
                      We work with tens of thousands of IT professionals and have a large client base. Our IT connections enable us to bring things to life and create functional settings. We extend our services at this time if you need to hire and train our personnel in a variety of sectors, or if you need an outsourced, managed, or project-based service. We meet our deadlines and provide our clients with high-quality IT services
                    </p>
                  </div>
                </div>
              </div>

              <div className="w-full md:w-4/12 px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-lightBlue-400">
                      <i className="fas fa-retweet"></i>
                    </div>
                    <h6 className="text-xl font-semibold">
                      IT STAFFING SOLUTIONS
                    </h6>
                    <p className="mt-2 mb-4 text-blueGray-500">
                      The ability of assembling optimum performance teams that cop up with immediate changes makes us advantageous. With number of locations throughout the globe, uncompromising network and quality in staffing provides clients with the most qualified and skilled professionals at any point of time and anywhere.
                    </p>
                  </div>
                </div>
              </div>

              <div className="pt-6 w-full md:w-4/12 px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-emerald-400">
                      <i className="fas fa-fingerprint"></i>
                    </div>
                    <h6 className="text-xl font-semibold">
                      Technical training
                    </h6>
                    <p className="mt-2 mb-4 text-blueGray-500">
                      We provide intensive training to our employees in subjects such as DevOps, Full-Stack development, Java, Hadoop, Data Science, Workflow automation, Salesforce, and other leading technologies. Our developers stay current with the latest technical skills, so you always get the experts that are needed to make your projects a success.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap items-center mt-32">
              <div className="w-full md:w-5/12 px-4 mr-auto ml-auto">
                <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                  <i className="fas fa-user-friends text-xl"></i>
                </div>
                <h3 className="text-3xl mb-2 font-semibold leading-normal">
                  PRODUCT DELIVERY TEAMS
                </h3>
                <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-blueGray-600">
                  A modern software product today requires cross-domain competence, and to create a compelling experience, designers, backend developers, front-end developers, AI/ML experts, QA experts, and DevOps experts, are required. Hiring such a broad group of people can take months, and new hires typically need time to get up to speed before they can contribute to your initiatives. Tech Talent Connect provides Managed Agile Teams that can get up and operating right away. We also oversee the team's productivity and production. Our teams use the best agile development approaches available. Daily standups, reports, and KPIs provide you complete visibility into the team's work. By automating your product development efforts, you can focus on more strategic issues to grow your business
                </p>
              </div>

              <div className="w-full md:w-4/12 px-4 mr-auto ml-auto">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg bg-lightBlue-500">
                  <img
                    alt="..."
                    src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1051&q=80"
                    className="w-full align-middle rounded-t-lg"
                  />
                  <blockquote className="relative p-8 mb-4">
                    <svg
                      preserveAspectRatio="none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 583 95"
                      className="absolute left-0 w-full block h-95-px -top-94-px"
                    >
                      <polygon
                        points="-30,95 583,95 583,65"
                        className="text-lightBlue-500 fill-current"
                      ></polygon>
                    </svg>
                    <h4 className="text-xl font-bold text-white">
                      Career With Us
                    </h4>
                    <p className="text-md font-light mt-2 text-white">
                      Tech Talent Connect is an Information Technology Consulting and Staffing Firm. Over the course of years Tech Talent Connect has established itself as one of the premiere firms providing services to banking, financial, entertainment and insurance clients, among other industries.Our business model is designed to provide services to a few premiere clients in a joint partnership to enhance performance and delivery.
                    </p>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="relative py-20">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-white fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>

          <div className="container mx-auto px-4">
            <div className="items-center flex flex-wrap">
              <div className="w-full md:w-4/12 ml-auto mr-auto px-4">
                <img
                  alt="..."
                  className="max-w-full rounded-lg shadow-lg mb-50"
                  src="https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80%20870w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80%201170w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80%201470w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80%201740w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80%201770w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80%202070w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80%202340w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2370&q=80%202370w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80%202670w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2940&q=80%202940w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2970&q=80%202970w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3270&q=80%203270w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3540&q=80%203540w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3570&q=80%203570w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3870&q=80%203870w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=4140&q=80%204140w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=4170&q=80%204170w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=4470&q=80%204470w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=4740&q=80%204740w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=4770&q=80%204770w,%20https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=4827&q=80%204827w"
                />
              </div>
              <div className="w-full md:w-5/12 ml-auto mr-auto px-4">
                <div className="md:pr-12">
                  <div className="text-lightBlue-600 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-lightBlue-300">
                    <i className="fas fa-rocket text-xl"></i>
                  </div>
                  <h3 className="text-3xl font-semibold">Industry Relevant</h3>
                  <p className="mt-4 text-lg leading-relaxed text-blueGray-500">
                    Industry-tested curriculum to make you job ready. There is
                    an opportunity to work on the live projects inside the
                    company. To get hands-on experience by working with the team
                    of veterans who have been doing excellent in their current
                    roles
                  </p>
                  <ul className="list-none mt-6">
                    <li className="py-2">
                      <div className="flex items-center">
                        <div>
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-lightBlue-600 bg-lightBlue-200 mr-3">
                            <i className="fas fa-fingerprint"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="text-blueGray-500">
                            Carefully crafted syllabus
                          </h4>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="flex items-center">
                        <div>
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-lightBlue-600 bg-lightBlue-200 mr-3">
                            <i className="fab fa-html5"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="text-blueGray-500">
                            Amazing projects to work-on
                          </h4>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="flex items-center">
                        <div>
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-lightBlue-600 bg-lightBlue-200 mr-3">
                            <i className="far fa-paper-plane"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="text-blueGray-500">
                            Dynamic environment
                          </h4>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>


        </section>

        <div class="flex flex-wrap items-center"
         style={{
          marginBottom: 100
        }}
        >
    <div class="w-full md:w-6/12 px-4 mr-auto ml-auto">
        <div class="justify-center flex flex-wrap relative">
        <h3 class="text-3xl mb-2 font-semibold leading-normal">Get started with on demand Technologies</h3>
            <div class="my-4 w-full lg:w-6/12 px-4">
                    
                      <Flippy flipOnHover={false} flipOnClick={true} flipDirection="horizontal" style={{ width: '300px', height: '150px',padding:'0rem', }} >
                        <FrontSide style={{ width: '300px', height: '150px',padding:'0rem' }}> 
                        <div class="bg-red-600 shadow-lg rounded-lg text-center p-8 mt-8"><img alt="..."
                            class="shadow-md rounded-full max-w-full w-16 mx-auto "
                            src={java_img}/>
                        <p class="text-lg text-white mt-4 font-semibold">Java Full Stack Development</p>
                    
                    </div> </FrontSide>
                        <BackSide style={{ width: '300px', height: '150px',padding:'0rem' }}>
                          <div class="bg-red-600 shadow-lg rounded-lg text-center p-8 ">
                        <p class=" text-white  font-semibold">Full Stack Java developers are to create both front-end components, such as user interfaces and back-end components, such as application code and databases.</p>
                    
                    </div></BackSide>
                      </Flippy>
                        
                      <Flippy flipOnHover={false} flipOnClick={true} flipDirection="horizontal" style={{ width: '300px', height: '150px',padding:'0rem' }} >
                        <FrontSide style={{ width: '300px', height: '150px',padding:'0rem' }} > 
                        <div class="bg-lightBlue-500 shadow-lg rounded-lg text-center p-8 mt-8"><img alt="..."
                            class="shadow-md rounded-full max-w-full w-16 mx-auto "
                            src="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/logos/react.jpg"/>
                        <p class="text-lg text-white mt-4 font-semibold">UI Development</p>
                    
                    </div> </FrontSide>
                        <BackSide style={{ width: '300px', height: '150px',padding:'0rem' }}>
                           <div class="bg-lightBlue-500 shadow-lg rounded-lg text-center p-8 ">
                        <p class=" text-white font-semibold">UI Developers are responsible for the look, feel and presentation of web pages and applications while also ensuring their functionality and integration with backend.</p>
                    
                    </div></BackSide>
                      </Flippy>

                      <Flippy flipOnHover={false} flipOnClick={true} flipDirection="horizontal" style={{ width: '300px', height: '150px',padding:'0rem' }} >
                        <FrontSide style={{ width: '300px', height: '150px',padding:'0rem' }}> 
                        <div class="bg-blueGray-700 shadow-lg rounded-lg text-center p-8 mt-8"><img alt="..."
                            class="shadow-md rounded-full max-w-full w-16 mx-auto "
                            src={cloud_img}/>
                        <p class="text-lg text-white mt-4 font-semibold">Cloud Development</p>
                    
                    </div> </FrontSide>
                        <BackSide style={{ width: '300px', height: '150px',padding:'0rem' }}> 
                        <div class="bg-blueGray-700 shadow-lg rounded-lg text-center p-8 ">
                        <p class=" text-white font-semibold">Cloud developers are responsible for implementations and maintenance of cloud infrastructures. Top cloud providers are AWS, IBM, GCP, Azure, SAP, Oracle Cloud, Digital Ocean</p>
                    
                    </div></BackSide>
                      </Flippy>
                
                    
                </div>
            <div class="my-4 w-full lg:w-6/12 px-4 lg:mt-16">
                      <Flippy flipOnHover={false} flipOnClick={true} flipDirection="horizontal" style={{ width: '300px', height: '150px', padding:'0rem' }} >
                        <FrontSide style={{ width: '300px', height: '150px',padding:'0rem' }} > 
                        <div class="bg-yellow-500 shadow-lg rounded-lg text-center p-8 mt-8"><img alt="..."
                            class="shadow-md rounded-full max-w-full w-16 mx-auto  "
                            src={big_img}/>
                        <p class="text-lg text-white mt-4 font-semibold">Big Data Engineers</p>
                    
                          </div> </FrontSide>
                        <BackSide style={{ width: '300px', height: '150px',padding:'0rem' }} > 
                        <div class="bg-yellow-500 shadow-lg rounded-lg text-center p-8 ">
                        <p class=" text-white  font-semibold">Big data engineers develop, and maintain data solutions for a company and gather data from multiple sources where users can access the data efficiently.</p>
                    
                          </div></BackSide>
                      </Flippy>

                      <Flippy flipOnHover={false} flipOnClick={true} flipDirection="horizontal" style={{ width: '300px', height: '150px', padding:'0rem' }} >
                        <FrontSide style={{ width: '300px', height: '150px',padding:'0rem' }}> 
                        <div class="bg-red-700 shadow-lg rounded-lg text-center p-8 mt-8"><img alt="..."
                            class="shadow-md rounded-full max-w-full w-16 mx-auto "
                            src={net_img}/>
                        <p class="text-lg text-white mt-4 font-semibold">.Net Engineering</p>
                    
                    </div> </FrontSide>
                        <BackSide style={{ width: '300px', height: '150px',padding:'0rem' }} > 
                        <div class="bg-red-700 shadow-lg rounded-lg text-center p-8 ">
                        <p class=" text-white  font-semibold">.NET engineer provides expert computer programming analysis and development expertise to design, develop, test and implement and upgrades to Web applications.</p>
                        </div></BackSide>
                      </Flippy>

                      <Flippy flipOnHover={false} flipOnClick={true} flipDirection="horizontal" style={{ width: '300px', height: '150px',padding:'0rem' }} >
                        <FrontSide style={{ width: '300px', height: '150px',padding:'0rem' }}> 
                        <div class="bg-emerald-500 shadow-lg rounded-lg text-center p-8 mt-8"><img alt="..."
                            class="shadow-md rounded-full max-w-full w-16 mx-auto "
                            src={sf_img}/>
                        <p class="text-lg text-white mt-4 font-semibold">Salesforce Specialist</p>
                    
                    </div> </FrontSide>
                        <BackSide style={{ width: '300px', height: '150px',padding:'0rem' }}> 
                        <div class="bg-emerald-500 shadow-lg rounded-lg text-center p-8 ">
                        <p class="text-white font-semibold">Salesforce consultant is responsible to add value to the business so must be competent on the CRM platform and should be able to develop and provide a solution to the business problem.</p>
                        </div></BackSide>
                      </Flippy>
                    
               </div>
        </div>
    </div>
    <div class="w-full md:w-5/12 px-12 md:px-4 ml-auto mr-auto mt-48">
        
        <h3 class="text-3xl mb-2 font-semibold leading-normal">Our Mission</h3>
        <p class="text-lg font-light leading-relaxed mt-4 mb-4 text-blueGray-600">Provide information technology solutions that are innovative, flexible, cost-effective, and business-focused</p>
        <p class="text-lg font-light leading-relaxed mt-4 mb-4 text-blueGray-600">We guarantee exceptional accuracy, consistency, and honesty in the staffing and executive search process with our service. Our unparalleled performance sets us apart from the competition, which is why our clients and candidates choose Tech Talent Connect to identify the best match for each search.</p>
        <p class="text-lg font-light leading-relaxed mt-4 mb-4 text-blueGray-600">We deploy the best project managers, business analysts, and software developers in the ever-evolving spaces of AI, mobile technology, cyber security, network/system engineering, information security, data warehousing, cloud, and application development by developing industry-leading recruitment processes and utilizing innovative technologies, making us a leader in the tech talent industry. </p>
        <p class="text-lg font-light leading-relaxed mt-4 mb-4 text-blueGray-600"> We are firm believers in performing ethical business operations and cultivating values-based relationships with clients, workers, and anyone else that joins us in the organization's growth.</p>
        
    </div>
</div>

        <section className="pb-20 relative block bg-blueGray-800">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-blueGray-800 fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>

          <div className="container mx-auto px-4 lg:pt-24 lg:pb-64">
            <div className="flex flex-wrap text-center justify-center">
              <div className="w-full lg:w-6/12 px-4">
                <h2 className="text-4xl font-semibold text-white">
                  Why Choose Us
                </h2>
                <p className="text-lg leading-relaxed mt-4 mb-4 text-blueGray-400">
                  Find all the instructions you need to get an high paying job
                  in tech, even if you’ve never coded. Because learning to code
                  might be the easiest way to change your career.
                </p>
              </div>
            </div>
            <div className="flex flex-wrap mt-12 justify-center">
              <div className="w-full lg:w-3/12 px-4 text-center">
                <div className="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
                  <i className="fas fa-medal text-xl"></i>
                </div>
                <h6 className="text-xl mt-5 font-semibold text-white">

                  Our Working Process
                </h6>
                <p className="mt-2 mb-4 text-blueGray-400">
                  We have an organised working  process to reach our targets with discipline and perfection.
                </p>
              </div>
              <div className="w-full lg:w-3/12 px-4 text-center">
                <div className="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
                  <i className="fas fa-poll text-xl"></i>
                </div>
                <h5 className="text-xl mt-5 font-semibold text-white">
                  Dedicate Team
                </h5>
                <p className="mt-2 mb-4 text-blueGray-400">
                  Our dedicated team is our strength.We take care that we meet our deadlines  and doesn’t compromise with our performance.

                </p>
              </div>
              <div className="w-full lg:w-3/12 px-4 text-center">
                <div className="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
                  <i className="fas fa-lightbulb text-xl"></i>
                </div>
                <h5 className="text-xl mt-5 font-semibold text-white">
                  24/7 Hours Support
                </h5>
                <p className="mt-2 mb-4 text-blueGray-400">
                  We give 24/7 support to ensure that our client has no trouble at any point of time and we would be happy to assist them at any time.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="relative block py-24 lg:pt-0 bg-blueGray-800">
          <div className="container mx-auto px-4 my-4">
            <div className="flex flex-wrap justify-center lg:-mt-64 -mt-48">
              {/* <ChooseCard /> */}

              <div className="w-full lg:w-6/12 px-4 ">
                <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200">
                  {!formSubmitStatus ? (
                    <form
                      className="flex-auto p-5 lg:p-10"
                      onSubmit={submitContactUsForm}
                      id="contact-us-form"
                    >
                      <h4 className="text-2xl font-semibold">
                        Join the Millions!
                      </h4>
                      <p className="leading-relaxed mt-1 mb-4 text-blueGray-500">
                        {/* Learning to Code with NoHub */}
                      </p>
                      <div className="relative w-full mb-3 mt-8">
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="full-name"
                        >
                          Full Name*
                        </label>
                        <input
                          required
                          name="name"
                          onChange={handleFormStateChange}
                          type="text"
                          className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          placeholder="Full Name"
                        />
                      </div>

                      <div className="relative w-full mb-3">
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="email"
                        >
                          Email*
                        </label>
                        <input
                          required
                          name="email"
                          onChange={handleFormStateChange}
                          type="email"
                          className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          placeholder="Email"
                        />
                      </div>
                      <div className="relative w-full mb-3">
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="number"
                        >
                          Mobile Number
                        </label>
                        <input
                          name="phone"
                          onChange={handleFormStateChange}
                          type="number"
                          className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          placeholder="Mobile Number"
                        />
                      </div>
                      <div className="relative w-full mb-3">
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="message"
                        >
                          Message
                        </label>
                        <textarea
                          name="message"
                          onChange={handleFormStateChange}
                          rows="4"
                          cols="80"
                          className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                          placeholder="Enter your query..."
                        />
                      </div>
                      <div className="text-center mt-6">
                        <button
                          style={{ backgroundColor: "gray" }}
                          className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                          type="submit"
                          onClick={submitContactUsForm}
                          disabled={false}
                        >
                          Send Message
                        </button>
                      </div>
                    </form>
                  ) : (
                      <div className="text-center mt-6 mb-6">
                        <h3>Thank you for showing interest</h3>
                        <p> We will contact you soon!</p>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
